//token名称
export const SESSION_STORAGE_TOKEN = "token";
export const USER_KEY = "userInfo"
export const LOGIN_TIME = "loginTime"
export const LOGIN_ACCOUNT = "loginAccount"
export const LOGIN_PD = "loginPd"


export const YEK_SEA = '8102ee17c9a84786'

// 正式环境 限制访问列表（捐方、志愿者），测试环境置空即可
export const limitList = process.env.NODE_ENV === 'production' ? ['donationProject', 'volunteerApproval', 'volunteerJoin', 'myCertificate'] : []

// 打包环境标识，用于上线打包(控制菜单)  true正式， false测试
export const testStatus = process.env.NODE_ENV === 'production'
